import React from 'react';
import Blog5 from '../../containers/BlogContainers/Blog5';
import PageHeader from '../Shared/PageHeader';

const BlogSlide = () => {
    return (
        <div>
            <PageHeader title="Blog Details" />
            <Blog5 />
        </div>
    );
};

export default BlogSlide;